// extracted by mini-css-extract-plugin
export default {"mainTitle":"PageHeader_mainTitle__6q+wU","subTitle":"PageHeader_subTitle__yVMzg"};